export class RelatedLegs {
  tripId: number;
  legIds: Array<number>;
  taskCount: number;
}
